<template>
  <div>
    <PCNavbar :selectIndex="2"/>
    <MobileNavBar :currentActive="2" />
    <ProductList />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import ProductList from '@/components/product/ProductList.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    ProductList
  },
}
</script>

<style>
</style>
